export enum ServicesQueryParam {
  EDIT_TOWN = 'editTown',
}
